/**
 * Formata valores numéricos como moeda brasileira (BRL).
 * @param {number} value - O valor numérico a ser formatado.
 */
export function CurrencyFormat(value: number): string {
  const options: Intl.NumberFormatOptions = {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
  };
  const formatoMoeda = value.toLocaleString("pt-BR", options);

  return formatoMoeda;
}

/**
 * Formata valores numéricos como percentuais.
 * @param {number} value - O valor numérico a ser formatado.
 */
export function formatPercentage(value: number): string {
  // Garante que o valor é tratado como número
  const num = parseFloat(String(value));
  
  // Verifica se é um número válido
  if (isNaN(num)) return '0%';
  
  // Verifica se o número é inteiro ou tem decimais
  if (Number.isInteger(num) || num % 1 === 0) {
    // Número inteiro ou com decimal zero
    return `${Math.floor(num)}%`;
  } else {
    // Número com decimal não-zero
    return `${num.toFixed(2).replace(/\.?0+$/, '')}%`;
  }
}